/** @format */

declare global {
  namespace JSX {
    interface IntrinsicElements {
      math: {
        class: string;
        dangerouslySetInnerHTML: { __html: string };
        xmlns: string;
      };
    }
  }
}

type Props = {
  node: HTMLElement;
};

const Maths: React.FC<Props> = ({ node }) => {
  return (
    <math
      class={node.getAttribute("class") ?? ""}
      xmlns={node.getAttribute("xmlns") ?? ""}
      dangerouslySetInnerHTML={{ __html: node.innerHTML }}
    />
  );
};
export default Maths;
